import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonGaugeCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)
    const chartSizeO = specialStyle(document.body.clientHeight, 34)
    const chartSizeP = specialStyle(document.body.clientHeight, 60)
    const chartSizeQ = specialStyle(document.body.clientHeight, 85)

    let colorA = {
        x: 0, y: 1, x2: 0, y2: 0,
        colorStops: [
            { offset: 0, color: 'rgba(50, 197, 255, 0)' },
            { offset: 0.2, color: 'rgba(50, 197, 255, .3)' },
            { offset: 1, color: 'rgba(50, 197, 255, .8)' }
        ]
    }

    let colorB = {
        x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [
            { offset: 0, color: "rgba(255,255,255,1)" },
            { offset: 1, color: "rgba(255,255,255,0)" }
        ],
        global: false
    }

    // let colorC = "#32C5FF"

    let colorC = {
        x: 0, y: 0, x2: 1, y2: 0,
        colorStops: [
            { offset: 0, color: "#32C5FF" },
            { offset: 1, color: "#32C5FF" }
        ],
        global: false
    }

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },
            formatter: "{a} <br/>{b} : {c}%"
        },
        grid: {
            left: chartSizeJ,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        series: [
            // 第一大圆
            {
                name: "内部进度条",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '84%',
                min: params.minValue, //最小刻度
                max: params.maxValue, //最大刻度
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / params.maxValue, colorC],
                            [1, colorC]
                        ],
                        width: 2
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    color: "#ffffff"
                },
                detail: {
                    show: false,
                },
                title: { //标题
                    show: false,
                },
                data: [{
                    name: "",
                    value: params.num,
                }],
                pointer: {
                    show: true,
                    length: '70%',
                    radius: '20%',
                    width: 3 //指针粗细
                },
                animationDuration: 4000,
            },
            // 刻度 + 数值
            {
                name: '外部刻度',
                type: 'gauge',
                center: ['50%', '55%'],
                radius: '76%',
                min: params.minValue, //最小刻度
                max: params.maxValue, //最大刻度
                splitNumber: 10, //刻度数量
                startAngle: 225,
                endAngle: -45,
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        color: [[1, 'rgba(0,0,0,0)']]
                    }
                }, //仪表盘轴线
                axisLabel: {
                    show: true,
                    color: '#ffffff',
                    fontSize: chartSizeC,
                    fontFamily: 'Microsoft YaHei',
                    distance: -chartSizeO,
                    formatter: function (v) {
                        return v;
                        switch (v + '') {
                            case '0':
                                return '0';
                            case '10':
                                return '10';
                            case '20':
                                return '20';
                            case '30':
                                return '30';
                            case '40':
                                return '40';
                            case '50':
                                return '50';
                            case '60':
                                return '60';
                            case '70':
                                return '70';
                            case '80':
                                return '80';
                            case '90':
                                return '90';
                            case '100':
                                return '100';
                            case '110':
                                return '110';
                            case '120':
                                return '120';
                            case '130':
                                return '130';
                            case '140':
                                return '140';
                            case '150':
                                return '150';
                            case '160':
                                return '160';
                            case '170':
                                return '170';
                            case '180':
                                return '180';
                            case '190':
                                return '190';
                            case '200':
                                return '200';
                            case '210':
                                return '210';
                            case '220':
                                return '220';
                            case '230':
                                return '230';
                            case '240':
                                return '240';
                            case '250':
                                return '250';
                            case '260':
                                return '260';
                            case '270':
                                return '270';
                            case '280':
                                return '280';
                            case '290':
                                return '290';
                            case '300':
                                return '300';
                            case '310':
                                return '310';
                            case '320':
                                return '320';
                            case '330':
                                return '330';
                            case '340':
                                return '340';
                            case '350':
                                return '350';
                            case '360':
                                return '360';
                            case '370':
                                return '370';
                            case '380':
                                return '380';
                            case '390':
                                return '390';
                            case '400':
                                return '400';
                            case '410':
                                return '410';
                            case '420':
                                return '420';
                            case '430':
                                return '430';
                            case '440':
                                return '440';
                            case '450':
                                return '450';
                            case '460':
                                return '460';
                            case '470':
                                return '470';
                            case '480':
                                return '480';
                            case '490':
                                return '490';
                            case '500':
                                return '500';
                            case '510':
                                return '510';
                            case '520':
                                return '520';
                            case '530':
                                return '530';
                            case '540':
                                return '540';
                            case '550':
                                return '550';
                            case '560':
                                return '560';
                            case '570':
                                return '570';
                            case '580':
                                return '580';
                            case '590':
                                return '590';
                            case '600':
                                return '600';
                            case '610':
                                return '610';
                            case '620':
                                return '620';
                            case '630':
                                return '630';
                            case '640':
                                return '640';
                            case '650':
                                return '650';
                            case '660':
                                return '660';
                            case '670':
                                return '670';
                            case '680':
                                return '680';
                            case '690':
                                return '690';
                            case '700':
                                return '700';
                            case '710':
                                return '710';
                            case '720':
                                return '720';
                            case '730':
                                return '730';
                            case '740':
                                return '740';
                            case '750':
                                return '750';
                            case '760':
                                return '760';
                            case '770':
                                return '770';
                            case '780':
                                return '780';
                            case '790':
                                return '790';
                            case '800':
                                return '800';
                            case '810':
                                return '810';
                            case '820':
                                return '820';
                            case '830':
                                return '830';
                            case '840':
                                return '840';
                            case '850':
                                return '850';
                            case '860':
                                return '860';
                            case '870':
                                return '870';
                            case '880':
                                return '880';
                            case '890':
                                return '890';
                            case '900':
                                return '900';
                            case '910':
                                return '910';
                            case '920':
                                return '920';
                            case '930':
                                return '930';
                            case '940':
                                return '940';
                            case '950':
                                return '950';
                            case '960':
                                return '960';
                            case '970':
                                return '970';
                            case '980':
                                return '980';
                            case '990':
                                return '990';
                            case '1000':
                                return '1000';
                        }
                    }
                }, //刻度标签。
                axisTick: {
                    show: true,
                    splitNumber: 3,
                    lineStyle: {
                        color: colorB,
                        width: 1,
                    },
                    length: -chartSizeL
                }, //刻度样式
                splitLine: {
                    show: true,
                    length: 0,
                    lineStyle: {
                        color: colorB,
                        width: 1,
                    }
                }, //分隔线样式
                detail: {
                    show: false
                }
            },
            // 第二大圆
            {
                name: "内部小圆",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '68%',
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / params.maxValue, colorC],
                            [1, "rgba(0,0,0,0)"]
                        ],
                        width: chartSizeM
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    show: false,
                },
            },
            // 渐变色
            {
                name: "内部阴影",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '62%',
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [[params.num / params.maxValue, colorA], [1, 'rgba(28,128,245,0)']],
                        width: chartSizeI
                    },
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    show: false,
                },

            },
            // 第三大圆
            {
                name: "内部进度条",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '36%',
                min: params.minValue, //最小刻度
                max: params.maxValue, //最大刻度
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / params.maxValue, colorC],
                            [1, colorC]
                        ],
                        width: 1
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    color: "#ffffff"
                },
                detail: {
                    formatter: function (value) {
                        if (value !== 0) {
                            var num = Math.round(value);
                            return parseInt(num).toFixed(0)+params.filedUnit;
                        } else {
                            return 0;
                        }
                    },
                    offsetCenter: [0, chartSizeQ],
                    textStyle: {
                        padding: [0, 0, 0, 0],
                        fontSize: chartSizeD,
                        fontWeight: 500,
                        fontFamily: 'Microsoft YaHei',
                        color: "#FFF"
                    },
                },
                title: { //标题
                    show: true,
                    offsetCenter: [0, chartSizeP], // x, y，单位px
                    textStyle: {
                        color: "#FFF",
                        fontSize: chartSizeB, //表盘上的标题文字大小
                        fontWeight: 400,
                        fontFamily: 'Microsoft YaHei',
                    }
                },
                data: [{
                    name: params.series.name,
                    value: params.num,
                    
                }],
                pointer: {
                    show: true,
                    length: '70%',
                    radius: '20%',
                    width: 3 //指针粗细

                },
                animationDuration: 4000,
            },
            // 指针上的圆
            {
                type: 'pie',
                tooltip: {
                    show: false
                },
                hoverAnimation: false,
                legendHoverLink: false,
                radius: ['0%', '6%'],
                center: ['50%', '55%'],
                label: {
                    normal: {
                        show: false
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: [{
                    value: 120,
                    itemStyle: {
                        normal: {
                            color: "#ffffff",
                        },
                    }
                }]
            }
        ]
    }
    params.chartId.setOption(option, true)
}

export {
    commonGaugeCharts,
}